"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const demo_root_1 = require("../demo-root");
const demo_container_1 = require("../demo-container");
const theme_provider_1 = require("../../theme-provider");
const demo_theme_provider_with_toggle_1 = require("../demo-theme-provider-with-toggle");
exports.DemoWrapper = props => {
    const { direction = 'ltr', theme = 'main', showGrid, language = '' } = props;
    return (React.createElement(demo_root_1.DemoRoot, { hideMargin: true, showGrid: showGrid },
        React.createElement(theme_provider_1.ThemeProvider, { theme: theme },
            React.createElement(demo_theme_provider_with_toggle_1.DemoThemeProviderToggleContext.Provider, { value: {
                    hasImageTheme: theme === 'image',
                    direction: direction,
                    language
                } },
                React.createElement(demo_container_1.DemoContainer, { direction: direction, language: language, hasBackgroundImage: theme === 'image', withoutSpacings: true, key: `demo-container-${direction}` }, props.children)))));
};
